var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget__tree"},[(_vm.items.items.derived_from!== null)?_c('RecursiveIndent',{attrs:{"items":[_vm.items.items.derived_from]}}):_vm._e(),_c('RecursiveIndent',{attrs:{"items":[_vm.items.items]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }